import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex} from '../../../constants/general-variables';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthenticationHttpService} from '../../../services/http-services/authentication/authentication-http.service';

@Component({
  selector: 'tl-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  formTriedToSubmit = false;
  forgotPasswordForm!: FormGroup;
  isSpinnerActive = false;
  formSubmittedSuccess = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private authenticationHttpService: AuthenticationHttpService,
              private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.forgotPasswordForm.controls['email'].valueChanges.subscribe(value => {
      const trimmedValue = value.trim();
      if (value !== trimmedValue) {
        this.forgotPasswordForm.controls['email'].setValue(trimmedValue, { emitEvent: false });
      }
    });
  }

  buildForm(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
    });
  }

  onSubmitForgotPasswordForm(): void {
    this.formTriedToSubmit = true;
    if (this.forgotPasswordForm.valid) {
      this.isSpinnerActive = true;
      this.authenticationHttpService.forgotPasswordDeepLink(this.forgotPasswordForm.value).then((res: any) => {
        this.isSpinnerActive = false;
        this.formSubmittedSuccess = true;
      }).catch(e => {
        this.isSpinnerActive = false;
        this.formSubmittedSuccess = true;
      });
    }
  }
}
